import { Inject, inject, Injectable } from '@angular/core';
import { USER } from '../models/user';
import {
	EventCollectionI,
	LogCollectionI,
} from '../models/event.model';
import moment from "moment";
import { environment } from '../../../environments/environment';
import packageJson from '../../../../package.json';
import { addDoc, collection, CollectionReference, Firestore } from '@angular/fire/firestore';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/app.reducer';
import { selectUserId } from '../../store/auth/auth.selectors';
import { take } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class EventCollectorService {
	userId: number;
	// private mainCollect: CollectionReference<EventCollectorData>;
	private eventCollect: CollectionReference<EventCollectionI>;
	private logCollect: CollectionReference<LogCollectionI>;

	constructor(
		private store: Store<AppState>,
		private firestore: Firestore,
	) {
		this.store.select(selectUserId).pipe(take(1)).subscribe(v => this.userId = v!);
		// this.mainCollect = collection(this.firestore, 'traderFront') as CollectionReference<EventCollectorData>;
		this.eventCollect = collection(this.firestore, 'event') as CollectionReference<EventCollectionI>;
		this.logCollect = collection(this.firestore, 'log') as CollectionReference<LogCollectionI>;
	}

	async event(data: any) {
		await addDoc(this.eventCollect, {
			appVersion: packageJson.version,
			plattform: 'Web',
			device: window.navigator.userAgent,
			environment: environment.ENV,
			timestamp: moment().valueOf(),
			type: data.type,
			module: data.module,
			class: data.class,
			method: data.method,
			deviceId: '',
			userId: this.userId,
			data: data.data,
			name: data.name,
		});
	}

	async log(data: any) {
		await addDoc(this.logCollect ,{
			appVersion: packageJson.version,
			plattform: 'Web',
			device: window.navigator.userAgent,
			environment: environment.ENV,
			timestamp: moment().valueOf(),
			type: data.type,
			module: data.module,
			class: data.class,
			method: data.method,
			deviceId: '',
			userId: this.userId,
			data: data.data,
		});
	}
}
